import * as React from "react";
import {useEffect, useState} from "react";
import {Header} from "../components/Header";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../hooks/useAuth";
import {ArrowRight, Building2, Search, Star, User} from 'lucide-react';
import {Modal} from "../components/Modal";
import YellowPageOnboardingForm from "../components/YellowPageOnboardingForm";
import {t} from "i18next";

export const YellowPage = () => {
	const navigate = useNavigate();
	const {isAuthenticated} = useAuth();

	const [isYellowPageOnboardingFormModalOpen, setIsYellowPageOnboardingFormModalOpen] = useState(false);

	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');

	const categories = [
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.CATEGORIES.SHOPPING"),
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAZ_9Rv4iIB4b_ekfP7RGvnhgIFaKkma7Pz5wzqNjsP7MfCSmV18kpeCJoLVSAnK_KOHLMR0sXeLiqLh-Rx_fq3kZnRGLUM8UfXEQj6KqhB0EKXuX6iVaut2AmfOT1Ken0KjP6WzFZMNLB8kASrklcmJbFHIUM0g2MVaKlwKZkl8HD232L8ER3Tlf5uiPLsQc8PnOa6ZbxkXqtc8BZPgs-2ooNrVMzFTOIQJry8mmSJ3CokxIPS4EiF7kqBw8XEXZy9Q0d4fBs5bvE'
		},
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.CATEGORIES.FOOD_BEVERAGES"),
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDheoTB-hOBOgiti-uf7TZqh7bWmDZIjm3JGtC8SMqyiwUZoe-FRDhRejQwNYAH4oxODfxlCzpLbnhXg3N2-MQXDe0lwyPAH8NtjpoQQqmm-G4IzUG9-q-oF7ucsn_JguO7bdrwF9TZt-2YqBYIHPW5ku67YKToJIBHVFkp-oObDSIN56teivoSX7wLnF8TfcSn_wKL4suvvfhGux9CTgR-fiT9Jbk4z8e_Y6ZwggHj9mooE9eQ5ogIA7S15GIDR1TkTKo2VKTV3zM'
		},
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.CATEGORIES.BEAUTY_HEALTH"),
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCAGmjlUw1KoiSYs13nqCiUAitojnhs3yboK__kiCs9YHV1P8rW02dcSm34nShFlJatc6HjD3ELHkmX9WnihpieWWdpHEtk6zSO7aHnWHxEbG0AWRcjCBXMREpaSpvY0ExzACV_M2eIJb_08FZlrwszQWg8Mh9JPDKDISg6EziGToS2S7YSiBypdrgIC1UvBJPIOzQl4DU8DMtLOrKHrF4aqE8A163lHyxBNRCbiS4WqeUtQl_zN443tiqbAUj22RVKdt4gifMn0sQ'
		},
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.CATEGORIES.PROFESSIONAL_SERVICES"),
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuADVndgA910gxLn8vzPlFRtM5z_6FA0wXPdcb0ypw6y3aNp2LpRyWCbUP3LHCUecNYHv3jnIdH_tedX7rLnqoEwvTmFHEvTeIFfdu7pwLv2XNovQv_ex1r1ICEpIG8_gzLBliXmse7p-VggsfClaYWmmkdfW1XBfe_GmQZYAnEYM--005i43PLt8V7cih5c-go5HxJNGvvf-WP3g4a407vWhH9YunQtwjXtafQMsDpqbob5vDFtbLgT5LJgUV_5KIJA3nUBoCMvlKM'
		},
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.CATEGORIES.AUTOMOTIVE"),
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCloRWl5G0BxeVieyyTVAwwLJRII31BHi2fG2iIO6yT5i7AkAzu1wbJMWJ1lORpz3fgrMYb7V2xY7kULkIuJb9nF4Ca-YZA9wp5oDL765Iegn-jdYNTZkJhOB0NzUXv7ifYfDkC2Up7O-iDgasddOMTG9LAJB9Oyod9wQHRRn0Mj4FXd6aLmXy_yUAAdMykd0rQCGiDq56WLY4iYDIgOnF1vPuxRjocL4kQ6BN5Ozf3HjyS8vlM-O8-DHO38Fxsi4UD2H9geopawss'
		},
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.CATEGORIES.EDUCATION"),
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuByxFtTFryPPqBy81IUsMJPxnrTGTGX-8e3FKG__Hu1jMr8TqLC2EfXmlwCMVdB7z_--p0GIHcxN80r8NuE4pvPyNqofagWCfPZAp3alSjMnxoLJ1PwOP4oS3uvZymhXZh6y4IKcBXClYW68dYxbLCMaRDPNOvwb-lQ27UkXkKaBx2KbLVFm73hOfX4YkP7HiR9kLcLW4kTOy_-B56TcEtNeyOGKS8CaWjlD8BlLkhi9Wd8zROwTu6RJArGFpQNyyepzVdu8_4dFSM'
		},
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.CATEGORIES.EVENTS"),
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBVocD9WvMlyxL3bbT7Z35dDAxdwxKOP5k1hWXtw96raqpkCgDmFk4Zbt9mZXNeFjZpFqXHAl_ZFAZMbzsU92YfVRfkREAOYZ6UEMpIkaK2ijYbCz-HLhMdx7ECQctDhBsYAjlvAGVF459NVgtzub1QcTUQiRPbKzgDJucmMd8kGYrcL8L0RMFsqgFKgTkW_JIkjPBXZ-8ttP_6AWBbZzXxwbJuwJY7Dt96BwEw06ALJ5l3KMkAutJ5azGf9B3e37FAnvebvLMc_w8'
		}
	];

	const featuredBusinesses = [
		{
			name: 'TechFix Solutions',
			description: 'We sell and provide professional repair services for the latest mobile phones, laptops, and electronic gadgets from all brands.',
			image: '/assets/tech-filler-2.png',
		},
		{
			name: 'Ethnic Threads',
			description: 'Traditional and modern Maharashtrian attire',
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuB3VayHaK6HjWCPvcEKhEUaMnMdcGgFlq3-RaaB4fSIfiE4s_8tGVn8ZkYwwESr_5roz0JW2gG5qCHl5DvGwwVhLqs5exHeGOVvM6vnKu7rO8ge4u4OX5cvVfffNWVe3UkI-VTKklJwdbr8YSV4g2wJKdQ7Vj6wmLRc_QN3d8tGQ1w7StOtoEI-I6FYhEK_npsIf9Jut3Ws8r8caHmdkT13Yt1p73-7g37sCGC3QZmAeexYvdM2ypAB9og5RLc0qZP-3srMxTcoNKE'
		},
		{
			name: 'Radiant Beauty',
			description: 'Personalized beauty and wellness services',
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuARnYctKkZWu4Dkkw0kwZZK0g3ZHt0NzeJKLElM4J-7KTIofazkljnrODWGxcY8a3gEG4St_7_w5Q2OlFS4YnwIWPwABsST0AJuwF0AKOSE55VH2WV7Iq2H7mDTZMDLiesD7ASlrcUZHULsMDzXluE2ULkMRsj8y6tErBrrMKGarr64FdqXuH05WdLdVuclpfrMdwo2zmK0ynn-yeYAYz4cQELxRfZJRLEaGDbv4R_e3AiMtDFfWz4sFVUZY2BUwoTDnbJTxXZREU0'
		}
	];

	const newBusinesses = [
		{
			name: 'Shreeji Sweets',
			description: 'Finest Maharashtrian sweets',
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuC2GpNDTTcQpuLZ8DXNf2lrd-vSx1PAbsSkxksJdDIasryEqHIQCB-n-I74G0pjkJY21BT2frP-b3EzzeKnwfG4-b1nb2-VbnwFnQ47PNwu17UWbq5Lu3TpCuSsyBVZIYosqMAvPvHa5uPM_s3kwSHH3kjMjdcMaebvrDwW1CvM4zQ5epfmS_S5WAFjzKJjxOM3e16gTM9BSx1i5SBmzqyimoRkA0aX9uby9bFgEX4jxILB6Ovu-Tl1wukJVgZID0gNhgTLkwEYkGo'
		},
		{
			name: 'Omkar Real Estate',
			description: 'Trusted property solutions',
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCl6kxEkkS_Rh6LrQpmcVsN8eHZYgPbO6J4PYT2WZJOlP2K4IkY2Rejd93ZG_8tiAEh3df-KnoGYO2zjMBKbgBatdqt0jzodWPP89m5iYVo6qxQQnwX-yMaq_pfgc-x7gqrmb_CA4N4qPz1i6_wkP9KXg6agdC1AWelK-eScJ7i4AMFtwcVFGAVgrnRjste91pTs9WxXaZgVXybqr6kJxvlHkw3KSqEPl4E76DDyDKI-TZKrSoVW-obF0GdLRM_0o-oQ8LO99OIN14'
		},
		{
			name: 'Sai Packers & Movers',
			description: 'Reliable relocation services',
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuC6x9pIe3EkhRnHpRZGqoJd3waKH5OTQq4xGiAhGUFs5iEmUqu05LYB1s9rvDasL7PC9HtlByxG7qU3L3kFDScf-2ogDyrHOgTzYhuJN8a5yKb3hNkIhoP3nyr4ctPPer8q0igxY9juBY1uSp5z22At0monJu6fSdQSNQ6e4h_H7QkzG9LMTWvahzKbfCXo6DkDcz6TrJtbKdA53Rh_OulR227-5ha1NGWPpflTfrklrTCDCxm_YF86zhjXceZqsg-SRslNqmoYbyE'
		},
		{
			name: 'Ganesh Decorators',
			description: 'Event decoration specialists',
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAoZnsfG-8OtSvOul73yX9OJC4r5srJfuoRzeLzR4EBEYR_ONUR1ut1dafNpYbIrcvOAgh-lQLu6w41FFMofyJnpii-1KMlGEXx__VAmlVxzGoJnT1KwtEoZc5LkU0EUX0fQyugLcN71QjmlMA-42UEYnA5aDuj5LOD-ibcFz3gs6QZ1YxioRqYbYvuhODUbHEZ9zlFi3Q5x4kNMEfVm7DVNISZ3oqAKqJWXmtLDvOqPZl32CfBCLJbeKzJRiJ4n2bfNmMaOAqItdE'
		},
		{
			name: 'Laxmi Finance',
			description: 'Financial planning and services',
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCJbil1EVhUUi_0GWxITpUXsEUGWiNqz_nYLZFM6WXKd_4AxWdmETvaYkCHQiMOho9HuxZ45_7hE452wGBtQBsrtguKYIgnBuSxQMZjP7SOnK2p67BmUFIGzhdwmxT9ywR-IOPkSvCvNGSzBPID9YXtPI52UgROCo9QV6kpDeMqaJiFio_l-LIEJdxy98bUbeqI9PFYMhTfjd0QAzjRreaYvNrwQXc47JiKNk_JD5HqkGxd6D7OA-X6ahg_b8bwyiLXBBvBosXLph0'
		},
		{
			name: 'Patil Law Firm',
			description: 'Legal expertise and consultation',
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCyQV8s62cKTy87MCO0ZQwNunMS_Itwh53KNPqUt3JNC68vE4g0dOKzH1WBKPhV-0nvKhsboGVWVDJ92XxsogWjnvG2wxSC-BnkAewgJ4K4aIlfGHtevjpuGUkYlbOT1e0tMWDpJjDCMdg9blODtzQT7T712QVOc1jUsIFt6PnqruOUtRe7xn9rvAzWzMh2H9jWk_-eldIcMcyjGfVAne8cQ4ZGbmc7ZEp3VWyXWtADKhHDpfgHQQCqjYSxslyHH5cW1LE8xlahUmk'
		}
	];

	const testimonials = [
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.TESTIMONIALS.PRIYA_NAME"),
			time: t("YELLOW_PAGE.LANDING_PAGE.TESTIMONIALS.PRIYA_TIME"),
			rating: 5,
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAYozvVmebgfOPY6GnLCGUku_NgduqdOeoKHiCyyIlMNYRFFQCbG7CN9s5rQQ90ixelKkYlpl8RSaPYG4NJmhQ8QE0bItZ5N3qC6eDNmKR3uKe_uSPkRw71THqiQM5NPrz77ccnElFt5L2crBjAoAcYbaNpjapy1kYfNb82VzEicQcs8CdC-FW7ICTKTS1CciYJZI7iWX14h2C3474EkEm9k6bmAPBKsu-LRQBAtI9SyrG44iSrHJnNMxpiTvdPeGu6OWH8a1-Wp7s',
			text: 'Maharashtra Connect has been a game-changer for finding local businesses. I discovered a fantastic catering service for my daughter\'s wedding!'
		},
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.TESTIMONIALS.ARJUN_NAME"),
			time: t("YELLOW_PAGE.LANDING_PAGE.TESTIMONIALS.ARJUN_TIME"),
			rating: 4,
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuB8KLlvDZORxrQEzQ-q-H5MmSB0voI5OjbGDEsM9vRwU2hovciCvAvrYDY2avGqu_Kg7wdgNDbdGPMlZtBH-tf-B7Mrh_rppjwnLu1IuAorMyxVbWsLHDjlhkwJZ0cQAvnRc-pbQn2-ZvFsQst9ep4VnV3T-GwbcVc-pd6bxYGbL69NclWqgHLa1A8vQrg90VL1ijXYYIfz8uUWWHlSNzispby2MVIZiYmVTVFH3RkuBfAYINzzNWyfxujWO2e32Y0QQtmH0vx2sf0',
			text: 'I found a reliable electrician through the directory. The search filters are very helpful.'
		},
		{
			name: t("YELLOW_PAGE.LANDING_PAGE.TESTIMONIALS.SNEHA_NAME"),
			time: t("YELLOW_PAGE.LANDING_PAGE.TESTIMONIALS.SNEHA_TIME"),
			rating: 5,
			image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDrqT3drW_h2De-EpVENhiYmqnr6eeTBDbnXZI1wUUuSsoteaEP-x95VEkMY61E0QuTVuEB1uD1lZFaol1S1J4dRUeU0AlOZDpjJLxLli4vWWgLPrkNo1UFtqGNMQheu86ucadMSGuzemcaHgD2dGCVDJY3vpqrOafi77MPw4u8yIGJyX2SK9dfQYpRmTXGnpbLI0_PfdhIA5YC8mV4OGAKIo4SQUK08Lv9uOwWHy9mG2TSisUPSJ4JBLo25RWNzBr81GKxBOU2Yr0',
			text: 'The community discounts are a great perk. I saved a lot on beauty services this month. Highly recommended!'
		}
	];

	const handleSearch = () => {
		console.log('Searching for:', searchTerm);
		navigate("/yellow-page-search-results")
	};

	useEffect(() => {
		if (!isAuthenticated) {
			navigate("/login", {
				replace: true,
			});
		}
	}, []);

	return (
		<div
			className={`min-h-[100dvh] h-[100dvh] max-h-[100dvh]
                min-w-full w-full max-w-full 
                bg-white flex flex-col justify-end`}
		>
			<Header/>

			<div
				className={`bg-orange-50 text-gray-800
                    flex flex-col justify-between thin-scrollbar
                    overflow-y-scroll min-w-full w-full max-w-full

                    portrait:pt-[4.75rem] portrait:sm:pt-[6.25rem] portrait:jk:pt-[5.75rem]
                    landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]

                    portrait:min-h-[100dvh] portrait:h-[100dvh] portrait:max-h-[100dvh]
                    landscape:min-h-[100dvh] landscape:h-[100dvh] landscape:max-h-[100dvh]

                    portrait:pb-[0.75rem] portrait:pl-[0.75rem] portrait:pr-[0.75rem]
                    landscape:pb-[0.5rem] landscape:pl-[0.5rem] landscape:pr-[0.5rem]

                    portrait:gap-[0.75rem] landscape:gap-[0.5rem]`}
			>
				{/* Main Content */}
				<main>
					{/* Hero Section */}
					<section
						className={`relative min-h-[500px] 2xl:min-h-[750px] rounded-xl overflow-hidden
                            flex flex-col items-center justify-center
                            text-center p-8 bg-cover bg-center bg-no-repeat`}
						style={{
							backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url("https://lh3.googleusercontent.com/aida-public/AB6AXuDgUqBW7RcuCncouXW8Z1g2AZxF5COipZgJ0jDUr-rSVtKTjdR_gJf834cCK_tFn3BOaO1E44QbH2ONqtR5ZUQRfKuD0UnJZJI8tBKHW05JApbFf4SR77yT9vAr-BDQiRUnaw5gcEgwg-M5AmXU4mQQ_rEzFSkHcvNacWUjdRq_5lh3PReVUjUvM4C2nFqcVA5gtZ9Zy45RJY0UwBJmvLFfYWIxhDloZyI0LyJrw6hggdfh9c4kTh1AeA1L2LO2m-yQP0XwTgg5OBM")'
						}}
					>
						<div className="max-w-3xl">
							<h1 className="text-3xl md:text-5xl font-custom-black text-white drop-shadow-lg mb-6">
								{t("YELLOW_PAGE.LANDING_PAGE.HERO_SECTION.MAIN_HEADING")}
							</h1>
							<div className="flex flex-col sm:flex-row gap-2 max-w-xl mx-auto">
								<div className="relative flex-grow">
									<Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5"/>
									<input
										className="w-full h-14 pl-12 pr-4 rounded-lg font-custom-medium bg-orange-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
										placeholder={t("YELLOW_PAGE.LANDING_PAGE.HERO_SECTION.SEARCH_PLACEHOLDER")}
										type="text"
										value={searchTerm}
										onChange={(e) => setSearchTerm(e.target.value)}
									/>
								</div>
								<button
									onClick={handleSearch}
									className="flex items-center justify-center h-14 px-8 bg-orange-500 text-white rounded-lg text-base font-custom-bold hover:opacity-90 transition-opacity"
								>
									{t("YELLOW_PAGE.LANDING_PAGE.HERO_SECTION.SEARCH_BUTTON")}
								</button>
							</div>
						</div>
					</section>

					{/* Popular Categories */}
					<section className="py-16">
						<h2 className="text-3xl font-custom-bold mb-8 text-center text-gray-900">
							{t("YELLOW_PAGE.LANDING_PAGE.CATEGORIES.SECTION_TITLE")}
						</h2>
						<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-6">
							{categories.map((category, index) => (
								<div key={index} className="flex flex-col items-center gap-3 group cursor-pointer">
									<div
										className="w-24 h-24 bg-center bg-no-repeat bg-cover rounded-full border-4 border-transparent group-hover:border-orange-500 transition-all duration-300"
										style={{backgroundImage: `url(${category.image})`}}
									/>
									<p className="text-sm font-custom-medium text-center">{category.name}</p>
								</div>
							))}
						</div>
					</section>

					{/* Featured Businesses */}
					<section className="py-16">
						<h2 className="text-3xl font-custom-bold mb-8 text-center text-gray-900">
							{t("YELLOW_PAGE.LANDING_PAGE.FEATURED_BUSINESSES.SECTION_TITLE")}
						</h2>
						<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
							{featuredBusinesses.map((business, index) => (
								<div
									onClick={() => navigate("/yellow-page-entity-public-profile")}
									key={index}
									className="bg-white rounded-xl overflow-hidden shadow-lg
                                        hover:shadow-2xl transition-shadow duration-300
                                        transform hover:-translate-y-1"
								>
									<div
										className="w-full h-56 bg-center bg-no-repeat bg-cover"
										style={{backgroundImage: `url(${business.image})`}}
									/>
									<div className="p-6">
										<h3 className="text-xl font-custom-bold mb-2">
											{business.name}
										</h3>
										<p className="text-gray-600 text-sm font-custom-medium mb-4">
											{business.description}
										</p>
										<a className="font-custom-semi-bold text-orange-500 hover:text-orange-400 transition-colors inline-flex items-center gap-1"
										   href="#">
											{t("YELLOW_PAGE.LANDING_PAGE.FEATURED_BUSINESSES.VIEW_DETAILS")}
											<ArrowRight className="w-4 h-4"/>
										</a>
									</div>
								</div>
							))}
						</div>
					</section>

					{/* New to Directory */}
					<section className="py-16">
						<h2 className="text-3xl font-custom-bold mb-8 text-center text-gray-900">
							{t("YELLOW_PAGE.LANDING_PAGE.NEW_DIRECTORY.SECTION_TITLE")}
						</h2>
						<div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6">
							{newBusinesses.map((business, index) => (
								<div key={index}
								     className="bg-white rounded-lg overflow-hidden group cursor-pointer hover:shadow-lg transition-shadow">
									<div className="relative">
										<div
											className="w-full aspect-square bg-center bg-cover"
											style={{backgroundImage: `url(${business.image})`}}
										/>
										<div
											className="absolute top-2 right-2 bg-orange-500 text-white text-xs font-custom-bold px-2 py-1 rounded">
											{t("YELLOW_PAGE.LANDING_PAGE.NEW_DIRECTORY.NEW_BADGE")}
										</div>
									</div>
									<div className="p-4">
										<h3 className="font-custom-bold text-sm truncate">
											{business.name}
										</h3>
										<p className="text-xs text-gray-500 truncate font-custom-medium">
											{business.description}
										</p>
									</div>
								</div>
							))}
						</div>
					</section>

					{/* Business Spotlight */}
					<section className="py-16 flex flex-col items-center justify-center">
						<h2 className="text-3xl font-custom-bold mb-8 text-center text-gray-900">
							{t("YELLOW_PAGE.LANDING_PAGE.BUSINESS_SPOTLIGHT.SECTION_TITLE")}
						</h2>
						<div
							className="h-64 max-h-64 bg-white rounded-xl overflow-hidden shadow-lg lg:flex items-center w-[50%]">
							<img
								alt={"Business Spotlight"}
								src={"/assets/spotlight-filler-image.png"}
								className="lg:w-1/2 h-full aspect-auto object-contain"
								// style={{
								//     backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuDw2aF7K1Dff2sOWddUc-Fh52sk-HQWxgmeGFmO0XS96v_bygWPg_SW2XIH5w75znGD7JoRs4rWuG8B337gg2Vspp6XO1qkVf489qObuUzFgVhWM93-Vl4xt51EIFgEYUrapJhmIgI349QjZ1NjOEdPUWplBWZyz0HZi8PiULYIPOiaLpf59UrysLvLE0v5qh4YztUYRutBpA0K3om2Cqk5tATeOATpDa65WCVA_YqHK5z7E990yPwyKgBAjwXi1bnlUTTtEAUA--o")'
								// }}
							/>
							<div className="lg:w-1/2 p-8">
								<h3 className="text-2xl font-custom-bold mb-3">
									{t("YELLOW_PAGE.LANDING_PAGE.BUSINESS_SPOTLIGHT.STORY_HEADING")}
								</h3>
								<p className="text-gray-600 mb-6 font-custom-semi-bold">
									{t("YELLOW_PAGE.LANDING_PAGE.BUSINESS_SPOTLIGHT.STORY_DESCRIPTION")}
								</p>
								<button
									className="bg-orange-500 text-white font-custom-bold py-2 px-4 rounded-lg hover:opacity-90 transition-opacity">
									{t("YELLOW_PAGE.LANDING_PAGE.BUSINESS_SPOTLIGHT.READ_MORE_BUTTON")}
								</button>
							</div>
						</div>
					</section>

					{/*/!* Stats Section *!/*/}
					{/*<section className="py-16 bg-orange-100 rounded-xl">*/}
					{/*    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">*/}
					{/*        <div>*/}
					{/*            <p className="text-4xl font-custom-extrabold text-orange-500">500+</p>*/}
					{/*            <p className="text-lg font-custom-medium text-gray-700">Businesses</p>*/}
					{/*        </div>*/}
					{/*        <div>*/}
					{/*            <p className="text-4xl font-custom-extrabold text-orange-500">10,000+</p>*/}
					{/*            <p className="text-lg font-custom-medium text-gray-700">Members</p>*/}
					{/*        </div>*/}
					{/*        <div>*/}
					{/*            <p className="text-4xl font-custom-extrabold text-orange-500">50+</p>*/}
					{/*            <p className="text-lg font-custom-medium text-gray-700">Services</p>*/}
					{/*        </div>*/}
					{/*    </div>*/}
					{/*</section>*/}

					{/* Testimonials */}
					<section className="py-16">
						<h2 className="text-3xl font-custom-bold mb-8 text-center text-gray-900">
							{t("YELLOW_PAGE.LANDING_PAGE.TESTIMONIALS.SECTION_TITLE")}
						</h2>
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
							{testimonials.map((testimonial, index) => (
								<div key={index} className="bg-white p-6 rounded-lg shadow-md">
									<div className="flex items-center mb-4">
										<img
											alt={testimonial.name}
											className="w-12 h-12 rounded-full mr-4 object-cover"
											src={testimonial.image}
										/>
										<div>
											<p className="font-custom-bold">
												{testimonial.name}
											</p>
											<p className="font-custom-medium text-sm text-gray-500">
												{testimonial.time}
											</p>
										</div>
									</div>
									<div className="flex items-center mb-2">
										{[...Array(5)].map((_, i) => (
											<Star
												key={i}
												className={`w-5 h-5 ${i < testimonial.rating ? 'text-orange-500 fill-current' : 'text-gray-300'}`}
											/>
										))}
									</div>
									<p className="text-gray-600 font-custom-semi-bold">
										{testimonial.text}
									</p>
								</div>
							))}
						</div>
					</section>
				</main>

				{/* Footer */}
				<footer className="bg-gray-100">
					<div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
						<h2 className="text-3xl font-custom-bold mb-4 text-gray-900">
							{t("YELLOW_PAGE.LANDING_PAGE.FOOTER.CTA_HEADING")}
						</h2>
						<p className="max-w-2xl mx-auto text-gray-600 mb-8 font-custom-semi-bold">
							{t("YELLOW_PAGE.LANDING_PAGE.FOOTER.CTA_DESCRIPTION")}
						</p>
						{/*<button*/}
						{/*    className="bg-orange-500 text-white font-custom-bold py-3 px-8 rounded-lg hover:opacity-90 transition-opacity">*/}
						{/*    Register Now*/}
						{/*</button>*/}
					</div>
				</footer>
			</div>

			<div
				className="flex flex-col justify-center items-center absolute bottom-[2rem] sm:flex-row gap-6 bg-transparent min-w-full w-full max-w-full">
				{/* List Business Button */}
				<button
					onClick={() => {
						setIsYellowPageOnboardingFormModalOpen(true);
					}}
					className="flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 group min-w-max"
				>
					<Building2 className="w-6 h-6 mr-3"/>
					<span className="text-lg font-custom-semi-bold whitespace-nowrap">
                        {t("YELLOW_PAGE.LANDING_PAGE.LIST_YOUR_ENTITY")}
                    </span>
				</button>

				{/* View Profile Button */}
				<button
					onClick={() => navigate("/yellow-page-entity-profile")}
					className="flex items-center justify-center bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 group min-w-max"
				>
					<User className="w-6 h-6 mr-3"/>
					<span className="text-lg font-custom-semi-bold whitespace-nowrap">
                        {t("YELLOW_PAGE.LANDING_PAGE.VIEW_PROFILE")}
                    </span>
				</button>
			</div>

			<Modal
				isOpen={isYellowPageOnboardingFormModalOpen}
				onClose={() => setIsYellowPageOnboardingFormModalOpen(false)}
			>
				<YellowPageOnboardingForm
					setIsYellowPageOnboardingFormModalOpen={setIsYellowPageOnboardingFormModalOpen}
				/>
			</Modal>
		</div>
	);
};

